import React from "react";
import { FiInbox } from "react-icons/fi";

export default function NewsEmptyState() {
  return (
    <div className="flex min-h-[280px] items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-slate-100 text-3xl text-slate-400 dark:bg-slate-800 dark:text-slate-500">
          <FiInbox />
        </div>

        <h3 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
          Aucune actualité trouvée
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
          Essayez de modifier vos filtres ou créez une nouvelle actualité pour
          commencer à alimenter le site.
        </p>
      </div>
    </div>
  );
}